<template>
  <div>
    <div class="title">{{activityTitle}}</div>
    
    <refresh-list @onLoad="onLoad" :list="list" @onRefresh="init" ref="refreshList">
      <div class="card-content-lsy" v-for="(item, index) in list" :key="index">
        <div class="dealer-title">
          <span>{{item.customerName}}</span>
          <svg class="waves" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"
            viewBox="0 0 200 200" preserveAspectRatio="none" shape-rendering="auto">
            <defs>
              <path id="gentle-wave" d="M-.5,8.5c13,0,63-7,80-7s42,7,70,7c30,0,63-7,84-7s58,7,83,7,58-7,83-7v398H-.5Z" />
              <linearGradient id="orange_red" x1="0%" y1="0%" x2="100%" y2="0%">
                <stop offset="0%" style="stop-color:#FFF9F6; stop-opacity:0.4"/>
                <stop offset="100%" style="stop-color:#FFF0EA; stop-opacity:1"/>
              </linearGradient>
            </defs>
            <g class="parallax">
              <use xlink:href="#gentle-wave" x="-60" y="7" fill="url(#orange_red)" />
              <use xlink:href="#gentle-wave" x="-40" y="12" fill="#FFF0EA" />
            </g>
          </svg>
        </div>
        <div class="card-inner">
          <div class="card-text grid-item">
            <div class="orange">{{item.browseNumber}}</div>
            <div class="desc">浏览次数</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.browsePeopleNumber}}</div>
            <div class="desc">浏览人数</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.shareNumber}}</div>
            <div class="desc">二次分享</div>
          </div>
          <div class="card-text grid-item">
            <div class="orange">{{item.signUpNumber}}</div>
            <div class="desc">报名人数</div>
          </div>
        </div>
        <div class="card-footer">
          <div class="card-btn link-item" @click="to(item, '/store')">
            <span class="desc">门店</span>
            <span class="orange">({{item.storeNumber}})</span>
          </div>
          <div class="card-btn link-item" @click="to(item, '/stuff')">
            <span class="desc">职员</span>
            <span class="orange">({{item.staffNumber}})</span>
          </div>
          <div class="card-btn link-item" @click="to(item, '/user')">
            <span class="desc">用户</span>
            <span class="orange">({{item.customerNumber}})</span>
          </div>
        </div>
      </div>
    </refresh-list>
  </div>
</template>

<script>
import refreshList from '@/components/refresh-list/refresh-list'
export default {
  components: {
    refreshList
  },
  data() {
    return {
      list: [],
      pageNum: 1,
      pageSize: 20,
    }
  },
  computed: {
    activityId() {
      return this.$route.query.activityId
    },
    activityTitle() {
      return this.$route.query.activityTitle
    }
  },
  mounted() {
    this.init();
  },
  methods: {
    onLoad() {
      this.getList();
    },
    init() {
      this.pageNum = 1;
      this.list = [];
      this.getList();
    },
    getList() {
      let data = {
        filterData: {
          activityId: this.activityId,
        },
        pageNum: this.pageNum,
        pageSize: this.pageSize
      }
      this.$api.h5.queryDealerActivityStatisticList(data)
      .then(res=>{
        if(res.code == 200) {
          this.list.push(...res.data.list);
          this.pageNum = res.data.pageNum + 1;
          this.$refs['refreshList'].complete(res.data);
        }else{
          this.$refs['refreshList'].onFinish();
        }
      })
      .catch(err=>{
        this.$refs['refreshList'].onFinish();
      })
    },
    to(item, p) {
      this.$router.push({
        path: p,
        query: {
          customerId: item.customerId,
          customerName: item.customerName,
          ...this.$route.query,
          enterType: item.enterType,
          enterPrimaryKey: item.enterPrimaryKey
        }
      })
    }
  }
}
</script>

<style lang="stylus" scoped>
  .title
    font-size 16px
    font-weight bold
    color #333333
    margin 10px 15px
</style>